import { getCountry } from 'utils/country';
import { getTrackingServicesUser, getUserRole } from 'utils/user';
import { isExceptionPath } from 'utils/paths';
import { pendoExceptionPaths } from 'config/trackingServicesExceptionPaths';

export const initPendo = (currentUser, pathname, isExternalAccess = false) => {
  if (!window.pendo || !window.pendo.isReady || isExceptionPath(pathname, pendoExceptionPaths))
    return;

  const pendo = window.pendo;

  if (!pendo.isReady()) pendo.initialize();

  const availableUser = getTrackingServicesUser(currentUser, pathname, isExternalAccess);
  if (!availableUser || !getCountry()) return;

  pendo.identify({
    visitor: {
      id: availableUser.uid,
      full_name: availableUser.name,
      email: availableUser.email,
      role: getUserRole(availableUser),
      market: getCountry(),
      last_login: availableUser.lastLogin,
      created_at: availableUser.createdAt,
    },
  });
};
